import { ContactPerson } from './ContactPerson'

export enum CompanyType {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export type Customer = {
  uuid?: string
  name?: string
  contactPersonList?: ContactPerson[]
  branch?: string
  employeeAmount?: number
  companyType?: CompanyType
  imageKey?: string

  // dynamic properties
  projectCount?: number
}
